<script>
import { RouteStatus, RouteStatusMap } from "@/constants/trip.js";

export default {
  name: "RouteStatus",
  props: {
    status: String,
  },
  computed: {
    classes() {
      switch (this.status) {
        case RouteStatus.inProgress:
          return "bg-amber-lighten-2 text-grey-darken-3";
        case RouteStatus.completed:
          return "bg-green-lighten-2 text-white";
        case RouteStatus.planned:
          return "bg-indigo-lighten-2 text-white";
        default:
          return "";
      }
    },
    statusName() {
      return RouteStatusMap.find((item) => item.id === this.status)?.name;
    },
  },
};
</script>

<template>
  <v-chip :class="classes" class="status-label rounded-lg caption px-2" density="compact" size="small" v-bind="$props">
    {{ statusName }}
  </v-chip>
</template>
